var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header-basic text-center"},[_c('h1',[_c('img',{attrs:{"alt":_vm.lang.HEADER_TITLE,"width":"500","src":require("@/assets/image/logo-header.svg")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }